import React from 'react';
import { Box } from '@common-fe/common-fe';

import AuthorizedUsers from './AuthorizedUsers';
import CommunicationChannels from './CommunicationChannels';
import UserAccountsSecurity from './UserAccountsSecurity';
import UserVerificationStatus from './UserVerificationStatus';

interface Props {
  isEditMode?: boolean;
  isShowErrors?: boolean;
}

const RegistrationAndLogin: React.FC<Props> = ({ isEditMode, isShowErrors }) => {
  return (
    <Box direction="column" background="module" pad="spacing24" round="moduleRound">
      <Box>
        <UserAccountsSecurity isEditMode={isEditMode} />
      </Box>

      <Box margin={{ top: 'spacing24' }}>
        <UserVerificationStatus hideUserAccess />
      </Box>

      <Box
        margin={{ top: 'spacing24' }}
        background="canvas"
        round="container1Round"
        pad={{ vertical: 'spacing24', horizontal: 'spacing32' }}
      >
        <AuthorizedUsers />
      </Box>

      <Box margin={{ top: 'spacing24' }}>
        <CommunicationChannels isEditMode={isEditMode} isShowErrors={isShowErrors} />
      </Box>
    </Box>
  );
};

export default RegistrationAndLogin;
